import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-empty-state',
    template: `
    <div class="text-center text-muted py-5 empty-state-container">
      <i [class]="iconClass" style="font-size: 3rem; opacity: 0.3;"></i>
      <p class="mt-2 mb-0">{{ message }}</p>
      <ng-content></ng-content>
    </div>
  `,
    styles: [`
    .empty-state-container {
        min-height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
  `]
})
export class EmptyStateComponent {
    @Input() icon: string = 'ft-inbox';
    @Input() message: string = 'No items found.';

    get iconClass(): string {
        return `${this.icon} d-block mb-2`;
    }
}
